import Helper from "./Helper";

class Header {

  constructor() {
    this.maxDepth = 3;
    this.bUseCloseSubmenuTitle = true;

    this.body = document.querySelector('body');
    this.burgerToggles = Array.from(document.querySelectorAll('.js-burger-toggle'));
    this.searchToggle = document.querySelector('.js-search-toggle');
    this.searchContainerDesktop = document.querySelector('.search-container--desktop');
    this.menu = document.querySelector('.site-header__menu-container');
    this.menuItemWithChildSelector = '.menu__item--has-children';
    this.closeSubmenuSelector = '.submenu__back';
    this.mainMenu = document.querySelector('.menu__wrap--level-0');
    this.subMenus = null; // set after generating

    if (this.burgerToggles.length && this.mainMenu && this.menu) {
      this.generateSubmenus();
      this.openCurrentPath();
      this.bindEvents();
    }
  }

  openCurrentPath() {
    let activeSelector =
      '.menu__item--has-children.menu__item--parent-active,' +
      ' .menu__item--has-children.menu__item--ancestor-active,' +
      ' .menu__item--has-children.menu__item--active';

    if (!this.subMenus?.length) {
      return;
    }

    let found = document.querySelector(activeSelector);

    for (let i = 0; i < this.maxDepth - 1; i++) {
      if (found) {
        found.classList.add('menu__item--open');
        this.fillSubmenu(i, found);
        this.subMenus[i].classList.add('submenu--open');
        found = found.querySelector(activeSelector);
      } else {
        return;
      }
    }
  }


  generateSubmenus() {
    let submenus = '';
    for (let i = 1; i < this.maxDepth; i++) {
      submenus += `<div class="submenu" data-submenu="${i}"></div>`
    }
    if (!this.mainMenu) {
      return;
    }

    this.mainMenu.innerHTML += submenus;
    this.subMenus = document.querySelectorAll('.submenu');
  }

  bindEvents = () => {
    this.burgerToggles.forEach(toggle => toggle.addEventListener('click', this.toggleMenu));
    document.querySelectorAll(this.menuItemWithChildSelector).forEach(item => {
      item.addEventListener('click', this.openSubmenu);
    })
    document.querySelectorAll(this.closeSubmenuSelector).forEach(item => {
      item.addEventListener('click', this.closeSubmenu);
    })
    if (this.searchToggle) {
      this.searchToggle.addEventListener('click', this.toggleSearch);
    }
  }

  unbindEvents = () => {
    this.burgerToggles.forEach(toggle => toggle.removeEventListener('click', this.toggleMenu));
    document.querySelectorAll(this.menuItemWithChildSelector).forEach(item => {
      item.removeEventListener('click', this.openSubmenu);
    })
    document.querySelectorAll(this.closeSubmenuSelector).forEach(item => {
      item.removeEventListener('click', this.closeSubmenu);
    })
    if (this.searchToggle) {
      this.searchToggle.removeEventListener('click', this.toggleSearch);
    }
  }

  resetEvents = () => {
    this.unbindEvents();
    this.bindEvents();
  }

  // required for animation
  setBurgerOpen(bOpen) {
    this.burgerToggles.forEach(toggle => {
      if (!bOpen) {
        toggle.classList.remove('burger-open');
      } else {
        toggle.classList.add('burger-open');
      }
    });
  }

  toggleMenu = () => {
    if (this.bMenuOpen()) {
      this.closeMenu();
      this.setBurgerOpen(false);
      return;
    } else {
      this.openMenu();
      this.setBurgerOpen(true);
      return;
    }
  }

  toggleSearch = () => {
    if (this.bSearchOpen()) {
      this.closeSearchDesktop();
    } else {
      this.openSearchDesktop();
      this.closeMenu();
    }
  }

  bSearchOpen() {
    return this.searchContainerDesktop.classList.contains('search-open');
  }

  bMenuOpen() {
    return this.menu.classList.contains('menu-open');
  }

  openMenu() {
    this.menu.classList.add('menu-open');
    this.body.classList.add('menu-open');
    this.setBurgerOpen(true);
    if (Helper.isDesktop()) {
      this.closeSearchDesktop();
    }
    return;
  }

  closeSearchDesktop() {
    this.searchContainerDesktop.classList.remove('search-open');
    this.searchToggle.classList.remove('search-open');
    this.body.classList.remove('search-open');
  }

  openSearchDesktop() {
    this.searchContainerDesktop.classList.add('search-open');
    this.searchToggle.classList.add('search-open');
    this.body.classList.add('search-open');
  }

  closeMenu() {
    this.menu.classList.remove('menu-open');
    this.body.classList.remove('menu-open');
    this.setBurgerOpen(false);
    return;
  }

  closeSubmenu = (clickEvent) => {
    let clickChild = this.getFirstBackMenuItem(clickEvent.composedPath());

    if (clickChild) {
      let depth = this.getMenuItemDepth(clickChild);
      this.clearSubMenus(depth - 1);
      this.resetEvents();
    }
  }

  openSubmenu = (clickEvent) => {
    // console.log("duck", clickEvent);
    clickEvent.preventDefault();
    if (clickEvent) {
      let clickChild = this.getFirstMenuItemWithChild(clickEvent.composedPath());

      // console.log("click", clickChild);
      if (clickChild) {
        let depth = this.getMenuItemDepth(clickChild);

        // console.log("depth", depth);

        if (depth > 0) {
          this.subMenus[depth - 1].querySelectorAll('.menu__item--open').forEach(i => i.classList.remove('menu__link--open'));
        } else {
          this.mainMenu.querySelectorAll('.menu__item--open').forEach(i => i.classList.remove('menu__link--open'));
        }

        clickChild.classList.add('menu__item--open');

        if (depth < this.maxDepth) {
          this.clearSubMenus(depth);
          this.fillSubmenu(depth, clickChild);
          this.subMenus[depth].classList.add('submenu--open');
          this.resetEvents();
        }
      }
    }
  }

  fillSubmenu(depth, clickChild) {
    const targetSubmenu = this.subMenus?.[depth];
    const sourceContent = clickChild?.lastElementChild;

    if (!targetSubmenu || !sourceContent) {
      return;
    }

    const clonedContent = sourceContent.cloneNode(true);
    const submenuMenu = clonedContent.querySelector('.menu__inner');

    if (!submenuMenu) {
      return;
    }

    submenuMenu.innerHTML = this.buildBackLink(depth, clickChild) + submenuMenu.innerHTML;
    targetSubmenu.appendChild(clonedContent);
  }

  buildBackLink(depth, clickChild) {
    let title = '';
    if (depth == 0) {
      title = '<span class="menu__link-text">Primary Menu</span>';
    } else if (depth == 1) {
      let openLink = this.mainMenu.querySelector('.menu__item--open .menu__link');
      if (openLink) {
        title = openLink.cloneNode(true);
        if (title?.querySelector('.menu__arrow')) {
          title.removeChild(title.querySelector('.menu__arrow'));
        }
      }
      title = title.innerHTML;
    } else {
      title = this.bUseCloseSubmenuTitle ? this.subMenus[depth - 2].querySelector('.menu__item--open .menu__link').cloneNode(true) : '';
      if (title.querySelector('.menu__arrow')) {
        title.removeChild(title.querySelector('.menu__arrow'));
      }
      title = title.innerHTML;
    }
    return `<li class="menu__item menu__item--level-${depth + 1} menu__item--has-no-children submenu__back"><a href="#0" class="menu__link menu__link--level-${depth + 1}" >Back</a></li>`;
  }

  clearSubMenus(depth) {
    for (let i = depth; i < this.maxDepth - 1; i++) {
      this.subMenus[i].innerHTML = '';
      this.subMenus[i].classList.remove('submenu--open');
    }
  }

  getFirstBackMenuItem(path) {
    for (let i = 0; i < path.length; i++) {
      if (path[i].classList?.contains('submenu__back')) {
        return path[i];
      }
    }
  }

  getFirstMenuItemWithChild(path) {
    for (let i = 0; i < path.length; i++) {
      if (path[i].classList?.contains('menu__item--has-children')) {
        return path[i];
      }
    }
  }

  getMenuItemDepth(item) {
    let classList = item.classList;
    if (classList.contains('menu--main')) {
      return 0;
    } else {
      const classes = [...(Array(this.maxDepth).keys()).map(v => v = 'menu__item--level-' + v)];
      for (let i = 0; i < classes.length; i++) {
        if (classList.contains(classes[i])) return i;
      }
    }
  }
}



export default Header;
